import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useTransferRefund = () => {
  return useMutation({
    mutationFn: (data) => api.referral.refund(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось отправить данные',
        type: 'error',
      })
    }
  })
}
